type PreviewFileParams = {
  fileId: string;
  fileName: string;
  allowDownload?: boolean;
};

enum FileErrorType {
  // file size is zero identifier
  FileSizeZero = "1b77c287-c846-4f5e-9966-fab73028a2f5",
}

const fileRenderType = ["officeOnlineLInk", "pdfOnlineLink", undefined] as const;
type FileRenderType = (typeof fileRenderType)[number];

export type { PreviewFileParams, FileRenderType };
export { fileRenderType, FileErrorType };
